/**
 * MMA - Prevents white bar bug on load.
 * Applies `overflow-x: hidden` to #page on load and removes it after 1 second.
 * The removal ensures sticky properties remain functional.
 */
document.addEventListener('DOMContentLoaded', function () {
  let pageElement = document.querySelector('#page');
  if (pageElement) {
    pageElement.style.overflow = 'hidden';

    window.addEventListener('load', function () {
      setTimeout(function () {
        pageElement.style.overflow = '';
      }, 400);
    });
  }
});
